// extracted by mini-css-extract-plugin
export default {"cardsContainer":"CardProcessos_cardsContainer__NK21r","ionCard":"CardProcessos_ionCard__ClyL0","btns":"CardProcessos_btns__gErHo"};